// src/components/Breadcrumbs.js
import React from 'react';
import { Link, useLocation, matchPath } from 'react-router-dom';
// import breadcrumbConfig from '../config/breadcrumbConfig';
import breadcrumbConfig from './breadcrumbConfig';

const Breadcrumbs = () => {
  const location = useLocation();
  const pathname = location.pathname;

  const matchBreadcrumb = () => {
    for (const pattern in breadcrumbConfig) {
      if (matchPath({ path: pattern, end: true }, pathname)) {
        return breadcrumbConfig[pattern];
      }
    }
    return ['Home'];
  };

  const breadcrumbTrail = matchBreadcrumb();

  return (
    <nav aria-label="breadcrumb">
      <ol className="breadcrumb mb-2">
        {breadcrumbTrail.map((crumb, idx) => (
          <li
            key={idx}
            className={`breadcrumb-item ${idx === breadcrumbTrail.length - 1 ? 'active' : ''}`}
            aria-current={idx === breadcrumbTrail.length - 1 ? 'page' : undefined}
          >
            {idx !== breadcrumbTrail.length - 1 ? (
              <Link to="#">{crumb}</Link> // Optional: make this dynamic
            ) : (
              crumb
            )}
          </li>
        ))}
      </ol>
    </nav>
  );
};

export default Breadcrumbs;
